export const ENV = {
  supabaseUrl: (import.meta.env.VITE_SUPABASE_URL as string | undefined) || 'http://127.0.0.1:56321',
  supabaseAnonKey: (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ||
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0',
  /** Empty means same origin; the dev server proxies /api and /agent to the Worker. */
  apiBase: (import.meta.env.VITE_API_BASE as string | undefined) || '',
  /** Sign-up and login options: the global router in production (it picks the region's cell), else the API base. */
  publicApiBase: (import.meta.env.VITE_PUBLIC_API_BASE as string | undefined) || (import.meta.env.VITE_API_BASE as string | undefined) || '',
  mock: import.meta.env.VITE_MOCK === '1',
}
